<template>
    <div class="aba-produto select-modal">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-toltip-aba-campanha"
                    />
                </div>
                <div class="column" :class="[permissao.create ? 'is-2' : 'is-3']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissao.create && !integracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularCampanha"
                    >
                        {{ $t('vincular-campanha') }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoCampanha.create && !campanhaIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroCampanha = !showModalCadastroCampanha"
                    >
                        {{ $t('adicionar-campanha') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="campanhaproduto"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'tabelapreco'">
                            <span
                                class="tag is-info status-tag"
                                :style="props.row.cor ? `background-color: ${props.row.cor}` : ''"
                            >
                                {{ props.row[f.key] }}
                            </span>
                        </div>

                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !integracao"
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>

                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>

                        <div v-else-if="f.key === 'valor' || f.key === 'valorminimo'">
                            {{
                                getDecimal(props.row[f.key] , null, true)
                            }}
                        </div>

                        <div v-else-if="f.key == 'descricao'">
                            <a @click="selectedEdit(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>

                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <CampanhaModal
                        :idcampanhaproduto="idcampanhaproduto"
                        :idProduto="$route.params.id"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>

            <!-- MODAL DE CADASTRO -->
            <b-modal :active.sync="showModalCadastroCampanha">
                <div>
                    <CampanhaCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastradaCampanha"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssCampanhaProdutoService from '@/services/vendas/produto/AssCampanhaProdutoService';
import CampanhaModal from '@/components/vendas/produto/modal/politica-comercial/campanha/CampanhaModal.vue';
import CampanhaCadastroModal from '@/components/vendas/produto/modal/politica-comercial/campanha/CampanhaCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';

// UTILS
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        CampanhaModal,
        CampanhaCadastroModal,
        HideInfo,
    },
    data() {
        return {
            campanhaproduto: [],
            cleanHide: true,
            fields: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'valor', width: 175, sortable: true, sortFn: null },
                { key: 'valorminimo', width: 175, sortable: true, sortFn: null },
                { key: 'tabelapreco', width: 200, sortable: true, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssCampanhaProdutoService(this.$http, this.$router),
            permissao: false,
            permissaoCampanha: false,
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CAMPANHAPRODUTO'),
            campanhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('CAMPANHA'),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            showModalCadastroCampanha: false,
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            idcampanhaproduto: null,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-campanha'
        );

        this.permissaoCampanha = this.hasPermissionAccess('vendas', 'produtos', 'campanhas');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-campanha' },
            });

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        selectedEdit(select) {
            this.idcampanhaproduto = select.idcampanhaproduto;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        decimalPlaces(n) {
            let places = typeof n != 'number' ? 2 : n > 8 ? 8 : n < 0 ? 0 : n;
            return {
                minimumFractionDigits: places,
                maximumFractionDigits: places,
            };
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findByIdProduto(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.$route.params.id,
                    this.situacaoSelected.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.campanhaproduto = value;
                    this.isEmpty = this.campanhaproduto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                    console.error(e);
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcampanhaproduto: m.idcampanhaproduto,
                    descricao: m.campanha.descricao,
                    valor: m.valor,
                    valorminimo: m.valorminimo,
                    tabelapreco: m.tabpreco.descricao,
                    simbolomonetario: m.tabpreco.moeda.simbolomonetario,
                    cor: m.tabpreco.cor,
                    situacao: m.situacao,
                    campanha: m.campanha,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('campanha') }
                );

            let tempAssCampanhaProduto = {
                idcampanhaproduto: this.delete.idcampanhaproduto,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssCampanhaProduto)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('campanha') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularCampanha() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.isUpdate = false;
            this.showModalCadastroCampanha = false;
            this.carregarDados();
        },
        cadastradaCampanha(campanha) {
            this.showModalCadastroCampanha = false;
            this.isUpdate = false;
            this.showModalAssociacao = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
